import React from "react";
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Button,
} from "@chakra-ui/react";
import { useTranslation } from "next-i18next";

import { Product } from "@/types/product";

export enum DialogType {
  End = "end",
  Refresh = "refresh",
}

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  product: Product;
  variant: DialogType;
};

const EndOrRefreshDialog = ({
  isOpen,
  onClose,
  onConfirm,
  product,
  variant,
}: Props): React.ReactElement => {
  const cancelRef = React.useRef();
  const { t } = useTranslation();

  return (
    <AlertDialog
      motionPreset="slideInBottom"
      leastDestructiveRef={cancelRef}
      onClose={onClose}
      isOpen={isOpen}
      isCentered
      preserveScrollBarGap
      size={"lg"}
    >
      <AlertDialogOverlay />
      <AlertDialogContent>
        <AlertDialogHeader>
          {variant === DialogType.End ? t("endProduct") : t("refreshProduct")}
        </AlertDialogHeader>
        <AlertDialogBody fontSize={"md"}>
          {variant === DialogType.End
            ? t("endProductInfo", {
                name: product?.name,
              })
            : t("refreshProductInfo", {
                name: product?.name,
              })}
        </AlertDialogBody>
        <AlertDialogFooter>
          <Button size="sm" ref={cancelRef} onClick={onClose} variant="ghost">
            {t("cancel")}
          </Button>
          <Button
            size="sm"
            ml={2}
            onClick={onConfirm}
            variant={variant === DialogType.End ? "solid" : "green"}
          >
            {variant === DialogType.End ? t("finish") : t("refreshProduct")}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default EndOrRefreshDialog;
